import {createReducer, on} from '@ngrx/store';
import * as contactsActions from './contacts-actions';
import * as fromContacts from './contacts-state';
import {ContactPagedResponse} from '@app/marketplace/checkout/_models/contact.model';
import {initProvinces} from '@app/marketplace/locations/locations';

const initialState: fromContacts.State = {isLoading: false, data: {count: 0, totalCount: 0} as ContactPagedResponse};
export const reducer = createReducer(
  initialState,
  on(contactsActions.LoadingContacts, (state) => {
    return {...state, isLoading: true};
  }),
  on(contactsActions.ListContacts, (state, {data}) => {
    return {...state, isLoading: false, data};
  }),
  on(contactsActions.AddingContact, (state) => {
    return {...state, isUpdating: true};
  }),
  on(contactsActions.AddedContact, (state, {data}) => {
    return {...state, isUpdating: false};
  }),
  on(contactsActions.SelectingDefaultContact, (state) => {
    return {...state, isUpdating: true};
  }),
  on(contactsActions.SelectedDefaultContact, (state) => {
    return {...state, isUpdating: false};
  }),
  on(contactsActions.UpdatingContact, (state) => {
    return {...state, isLoading: true};
  }),
  //on(contactsActions.UpdatedContact, (state, {data, payload}) => {
    /*if (data.success) {
      const province = initProvinces.find(p => p.children.find(m => m.value == data.data.location));
      const municipality = province.children.find(m => m.value == data.data.location);
      state.data.data.map(x => { if (x.code == code) {
        x.isDefault = data.data.isDefault;
        x.address.addressLine1 = data.data.addressLine1;
        x.address.addressLine2 = data.data.addressLine1;
        x.address.zipCode = data.data.zipCode;
        x.address.state = province.text || '';
        x.address.city = municipality.text || '';
        x.phone = data.data.phone;
        x.firstName = data.data.firstName;
        x.lastName = data.data.lastName;
        x.email = data.data.email;
        x.identity = data.data.identity;
        x.note = data.data.note;
        x.town = data.data.town;
        x.municipality = data.data.location;
        x.province = province?.value;
      }});
    }*/
    /*const items = state.data.data;
    return {...state, isLoading: false, data: {data: items}};
  }),*/
  on(contactsActions.CleaningContacts, (state) => {
    return initialState;
  }),
  on(contactsActions.RemovingContact, (state) => {
    return {...state, isLoading: true};
  }),
  /*on(contactsActions.RemovedContact, (state, {data, codes}) => {
    const items = state.data.data.filter(x => !codes.includes(x.code));
    return {...state, isLoading: false, data: {data: items}};
  }),*/
  on(contactsActions.ErrorContactsRequest, (state) => {
    return {...state, isLoading: false};
  }),
  on(contactsActions.CancelContactsRequest, (state) => {
    return {...state, isLoading: false};
  }),

);
